import {
  Button,
  Card,
  CardContent,
  Container,
  TextField,
  Typography,
  Tab,
  Box,
} from '@mui/material';
import { TabPanel, TabList, TabContext } from '@mui/lab';
import { useState } from 'react';
import ProjectList from '../components/ProjectList';
import RelatedProjectList from '../components/RelatedProjectList';
import ScriptManager from '../components/ScriptManager';
import ProjectOperationCard from 'components/ProjectOperationCard';
import CreateProjectCard from 'components/CreateProjectCard';
import useAppStore from 'store/useAppStore';
import TempProjectList from 'components/TempProjectList';
import ReadOnlyProjectList from 'components/ReadOnlyProjectList';

const Main = () => {
  const [initProjectSelected, setInitProjectSelected] = useState(''); // '', upload, fromDB

  const selectedProjectId = useAppStore(
    (state) => state.selectedProject.project_id,
  );
  const readOnly = useAppStore((state) => state.selectedProject.readOnly);
  const newProject = useAppStore((state) => state.newProject);
  const setNewProjectName = useAppStore((state) => state.setNewProjectName);
  const clearSelectedProject = useAppStore(
    (state) => state.clearSelectedProject,
  );
  const handleProjectNameChange = (e) => {
    setNewProjectName(e.target.value);
  };
  const [tab, setTab] = useState('create');
  const handleChange = (event, newValue) => {
    setTab(newValue);
    clearSelectedProject();
  };
  return (
    <Container
      maxWidth={false}
      className="mt-6 gap-6 flex flex-row justify-center max-w-[1920px] max-[1280px]:flex-col print:hidden"
    >
      <div className="flex flex-col gap-6">
        <Card>
          <CardContent>
            <TabContext value={tab}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label="新建專案" value="create" />
                  <Tab label="編輯暫存檔" value="edit" />
                  <Tab label="檢視專案" value="readOnly" />
                </TabList>
              </Box>
              <TabPanel value="create" className="px-0">
                <Typography variant="h6">報價單＆配置圖</Typography>
                <TextField
                  className="mt-4"
                  label="專案名稱"
                  fullWidth
                  value={newProject.name}
                  onChange={handleProjectNameChange}
                  placeholder="請輸入專案名稱"
                />
                <div className="flex gap-2 mt-4 min-w-[290px]">
                  <Button
                    fullWidth
                    size="large"
                    color={
                      initProjectSelected === 'upload' ? 'primary' : 'inherit'
                    }
                    variant="contained"
                    onClick={() => {
                      setInitProjectSelected(
                        initProjectSelected === 'upload' ? '' : 'upload',
                      );
                      clearSelectedProject();
                    }}
                  >
                    上傳檔案
                  </Button>
                  <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    color={
                      initProjectSelected === 'fromDB' ? 'primary' : 'inherit'
                    }
                    onClick={() => {
                      setInitProjectSelected(
                        initProjectSelected === 'fromDB' ? '' : 'fromDB',
                      );
                      clearSelectedProject();
                    }}
                  >
                    從資料庫選擇
                  </Button>
                </div>
                {initProjectSelected === 'fromDB' && <ProjectList />}
              </TabPanel>
              <TabPanel value="edit" className="px-0">
                <TempProjectList />
              </TabPanel>
              <TabPanel value="readOnly" className="px-0">
                <ReadOnlyProjectList />
              </TabPanel>
            </TabContext>
          </CardContent>
        </Card>
        {initProjectSelected === 'upload' && <CreateProjectCard />}
        {selectedProjectId !== '' && (
          <>
            <ProjectOperationCard />
            {readOnly === false && <RelatedProjectList />}
          </>
        )}
      </div>
      {selectedProjectId && <ScriptManager />}
    </Container>
  );
};

export default Main;
